import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.OrganizationStructureEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    organizationStructureEnumList: { items: data, total },
  } = await sdk.getListOrganizationStructureEnum(
    filterSortPage({ sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { organizationStructureEnum: data } =
    await sdk.getOneOrganizationStructureEnum({
      id,
    });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { organizationStructureEnumMany: data } =
    await sdk.getManyOrganizationStructureEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const organizationStructureEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
